import { render } from "./LinkAccountsShoutPanel.vue?vue&type=template&id=706d1bab&scoped=true"
import script from "./LinkAccountsShoutPanel.vue?vue&type=script&lang=js"
export * from "./LinkAccountsShoutPanel.vue?vue&type=script&lang=js"

import "./LinkAccountsShoutPanel.vue?vue&type=style&index=0&id=706d1bab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706d1bab"]])

export default __exports__